export default {
  getSurvey: state => ({ ...state.survey, questions: state.questions }),
  getSurveyQuestions: state => state.questions,
  getSurveyQuestion: state => index => state.questions[index]
}
